import React, { useEffect } from "react";
import styled from "styled-components";
import { COLORS } from "../../../COLORS";

const Mentions = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  return (
    <StyledMentions>
      <section className="first-box">
        <h1>Mentions Légales - Emohup.fr</h1>

        <h2>1. Identité de l'Éditeur du Site</h2>
        <p>
          <strong>Éditeur :</strong> Le site www.emohup.fr est édité par
          l’entreprise individuelle{" "}
          <a
            href="https://www.loryum.fr"
            target="_blank"
            rel="noopener noreferrer"
          >
            Loryum
          </a>
          , projet EmohUp.
          <br />
          <span>Entreprise individuelle de JEAN-JACQUES Lodrick</span>
          <br />
          <strong>Numéro SIRET :</strong> 992 781 260 00011
          <br />
          <strong>Adresse :</strong> 16 B Avenue de l'Europe, 51100 Reims,
          France
          <br />
          <strong>Adresse email :</strong> dev.frenchlod@gmail.com
          <br />
          <em>
            Loryum est une entreprise individuelle enregistrée en France. Le
            projet EmohUp est développé et géré sous sa responsabilité.
          </em>
        </p>

        <h2>2. Directeur de la Publication</h2>
        <p>
          {/* <strong>Directeur de la publication :</strong> */}
          <br />
          <strong>Adresse email :</strong> dev.frenchlod@gmail.com
        </p>

        <h2>3. Hébergeur du Site</h2>
        <p>
          <strong>Hébergeur :</strong> OVH
          <br />
          <strong>Adresse :</strong> 2 Rue Kellermann, 59100 Roubaix, France
          <br />
          <strong>Numéro de téléphone :</strong> +33 9 72 10 10 07
          <br />
          <strong>Adresse email de contact :</strong> support@ovh.com
        </p>

        <h2>4. Propriété Intellectuelle</h2>
        <p>
          Tous les contenus présents sur Emohup.fr (textes, images, logos,
          vidéos, etc.) sont protégés par le droit d'auteur et la propriété
          intellectuelle. Toute reproduction, distribution, modification ou
          utilisation sans autorisation préalable est interdite. Les marques et
          contenus de Loryum utilisés dans le cadre de l'affiliation restent la
          propriété de Loryum.
        </p>

        <h2>5. Conditions Générales d'Utilisation (CGU)</h2>
        <p>
          Les CGU sont disponibles sur le site et doivent être acceptées avant
          toute utilisation des services. L'utilisation des liens affiliés à
          Loryum est encadrée par ces conditions.
        </p>

        <h2>6. Politique de Confidentialité</h2>
        <p>
          Les données personnelles sont collectées et traitées conformément au
          RGPD. Les informations collectées peuvent inclure des données liées
          aux liens affiliés pour le suivi des commissions. Les utilisateurs
          disposent d'un droit d'accès, de rectification et de suppression de
          leurs données en contactant l'éditeur à l'adresse email indiquée.
        </p>

        <h2>7. Cookies</h2>
        <p>
          Emohup.fr utilise des cookies pour améliorer l'expérience utilisateur,
          analyser le trafic et suivre les liens affiliés. Un bandeau informe
          les utilisateurs lors de leur première visite et leur permet
          d'accepter ou de refuser les cookies.
        </p>

        <h2>8. Liens Externes</h2>
        <p>
          Le site peut contenir des liens vers des sites externes, notamment
          Loryum dans le cadre d'un programme d'affiliation. L'éditeur n'est pas
          responsable du contenu de ces sites externes mais informe que certains
          liens permettent de percevoir une commission.
        </p>

        <h2>9. Modifications des Mentions Légales</h2>
        <p>
          Les présentes mentions légales peuvent être modifiées à tout moment
          sans préavis. Les utilisateurs sont invités à consulter régulièrement
          cette page pour prendre connaissance des éventuelles modifications.
        </p>

        <h2>10. Droit Applicable</h2>
        <p>
          Les présentes mentions légales sont régies par le droit français. En
          cas de litige, seuls les tribunaux français sont compétents.
        </p>

        <h2>11. Contact</h2>
        <p>
          Pour toute question, réclamation ou demande d'information concernant
          les mentions légales, vous pouvez nous contacter à l'adresse suivante
          :
          <br />
          <strong>Adresse email :</strong> dev.frenchlod@gmail.com
        </p>
      </section>
    </StyledMentions>
  );
};

export default Mentions;

const StyledMentions = styled.div`
  height: 100%;
  width: 100%;
  overflow-y: scroll;
  h1 {
    font-size: 2.5em;
    letter-spacing: 0.4em;
    text-align: center;
  }
  .first-box {
    margin: 10px 0px;
    p {
      margin: 20px 0px;
      font-size: 1.1em;
      strong {
        color: ${COLORS.orange};
      }
    }
    h2 {
      margin: 15px 0px;
      font-size: 1.8em;
    }
    .info-important {
      margin: 20px auto;
      background: ${COLORS.blueLow};
      width: 50%;
      padding: 10px;
      color: ${COLORS.danger};
      text-align: center;
    }
  }
`;
